<template>
    <div>
        <div class="content-box">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item :label="title+':'" prop="name">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
                              :placeholder="'请输入'+maxlength+'字之内'"
                              v-model.trim="formItem.name"
                              clearable :maxlength="maxlength"
                              show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">保存</el-button>
        </p>
    </div>
</template>

<script>

import API from '@/api/marketManage/miBatchAuto.js';
export default {
    name: "adsEditModal",
    props:['title', 'maxlength', 'detail_id', 'type', 'text', 'cbs'],
    data(){
        return {
            formLoading:false,
            formItem:{
                name:'',
            },
            rules:{
                name: [
                    { required: true, message: '必填项、不可为空。', trigger: 'blur' },
                    { pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/, message: '不可包含特殊字符，只支持中文、数字、字母。', trigger: 'blur' }
                ],
            },
        }
    },
    mounted(){
    },
    watch:{
      'text': {
          handler(n) {
              this.formItem.name = n
          },
          immediate:true
      }
    },
    methods:{
        submitModal(){
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log('submit!');
                    this.fetchPostEditName()
                } else {
                    return false;
                }
            });
        },
        hideModal(){
            this.$emit('close');
        },
        fetchPostEditName() {
            console.log('提交结果',{detail_id:this.detail_id, type:this.type, name:this.formItem.name})

            API.postModifyInfo({detail_id:this.detail_id, type:this.type, name:this.formItem.name}).then(res=>{
                this.cbs.onSubmit({msg:'success'})
            },err=>{
                this.$message.error(err.info)
            })
        }
    }
}
</script>

<style scoped>

</style>
